import request from '@/utils/request'

const baseUrl = '/erp/product/category'

/** 维护用全量目录树（含停用） */
export function treeProductCategory () {
  return request({
    url: baseUrl + '/tree',
    method: 'get'
  })
}

/** 新建分类 */
export function addProductCategory (data) {
  return request({
    url: baseUrl + '/add',
    method: 'post',
    data
  })
}

/** 编辑分类 */
export function editProductCategory (data) {
  return request({
    url: baseUrl + '/edit',
    method: 'post',
    data
  })
}

/** 启用 */
export function enableProductCategory (id) {
  return request({
    url: baseUrl + '/enable',
    method: 'post',
    data: { id }
  })
}

/** 停用 */
export function disableProductCategory (id) {
  return request({
    url: baseUrl + '/disable',
    method: 'post',
    data: { id }
  })
}

/** 删除 */
export function deleteProductCategory (id) {
  return request({
    url: baseUrl + '/delete',
    method: 'post',
    data: { id }
  })
}
